import { ModalController } from '@ionic/angular';
import { Component, Input, OnInit } from '@angular/core';
import { ProductModel } from 'src/app/models/wardrobe.model';
import { PaginatedResponse } from 'src/app/models/paginated-response.model';
import { SwapSelectItemModalComponent } from './../swap-select-item-modal/swap-select-item-modal.component';

@Component({
  selector: 'shc-wardrobe-item-v1',
  templateUrl: './wardrobe-item-v1.component.html',
  styleUrls: ['./wardrobe-item-v1.component.scss'],
})
export class WardrobeItemV1Component implements OnInit {
  searchText: string;
  @Input() senderId: number;
  @Input() products: PaginatedResponse<ProductModel>;
  @Input() actualProductId: any;

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() { }

  async routeToSwapModal(item: ProductModel) {
    const modal = await this.modalCtrl.create({
      component: SwapSelectItemModalComponent,
      componentProps: {
        product: item,
        senderId: this.senderId,
        actualProductId: this.actualProductId
      },
      cssClass: 'my-custom-class',
      canDismiss: true,
      id: 'swapSelectItem'
    });
    modal.onDidDismiss().then((data) => {
      // manage the data after the SwapSelectItemModalComponent modal is closed
      if (data && data.data) {
        console.log(data);
        this.modalCtrl.dismiss(data.data, null, 'swapItem');
      }
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

}
